<div class="md:hidden flex w-full justify-center mt-4">
  @if (hasEvent()) {
    <div class="size-2 bg-primary rounded-full"></div>
  }
</div>
